export { default as SHSApp } from './App';



// WEBPACK FOOTER //
// ./packages/smart-home-support/index.ts